// extracted by mini-css-extract-plugin
export var audioPlayer = "_tn-0";